"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCardMedia = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledCardMedia = (0, styles_1.styled)(material_1.CardMedia, {
    shouldForwardProp: prop => prop !== "height",
})(({ height = 200 }) => ({
    backgroundSize: "contain",
    height,
}));
//# sourceMappingURL=index.js.map